import { computed, ref } from '@vue/composition-api'
import { required, requiredIf } from '@/utils/validations'

import useForm from '@/compositions/useForm'
import useRequest from '@/compositions/useRequest'

const prepareOrders = orders => orders.map(order => ({
  text: `№${order.id} – ${order.address}`,
  value: order.id,
}))

export default ({
  setup(props, context) {
    const { emit } = context
    const { $store } = context.root
    const readonly = ref(true)
    const files = ref([])

    const {
      validate, $errors, formData, getData, reset,
    } = useForm({
      fields: {
        orderId: { default: '', validations: { required } },
        text: { default: '', validations: { required: requiredIf(() => !files.value.length) } },
        file: { default: undefined },
      },
    })

    const addFile = (val) => {
      if (!Array.isArray(val)) {
        files.value.push(val)
        return
      }
      val.forEach((v) => {
        files.value.push(v)
      })
    }

    const removeFile = (index) => {
      files.value.splice(index, 1)
    }

    const getSizeTitle = (size) => {
      let newSize = size
      if (newSize < 1000) return `${newSize} Б`
      newSize /= 1000
      if (newSize < 1000) return `${newSize} КБ`
      newSize /= 1000
      return `${newSize} МБ`
    }

    const getFilesArray = () => {
      const filesArray = files.value.map(file => ({
        name: file.name,
        document_type: file.type,
        file,
      }))
      return filesArray
    }

    const getProperties = data => ({
      messagebleType: 'Order',
      messagebleId: data.orderId.value,
      text: data.text,
      documentsAttributes: getFilesArray(),
    })

    const { loading, makeRequest } = useRequest({
      context,
      successMessage: 'Сообщение отправлено!',
      successCallback: () => reset(),
      request: () => $store.dispatch('messages/postMessage', getProperties(getData())),
    })

    const submit = async () => {
      if (!validate()) return
      await makeRequest()
      files.value = []
      emit('close')
    }

    $store.dispatch('messages/fetchOrders')

    return {
      $errors,
      formData,
      submit,
      loading,
      readonly,
      orders: computed(() => prepareOrders($store.state.messages.orders)),
      files,
      addFile,
      removeFile,
      getSizeTitle,
    }
  },
})
